

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import ImageRow from './ImageRow';
const ParentComponent = () => {
  const images = [    
    // 'images/mobile-digital-marketing.png',
    // 'images/award02.png',
    // 'images/award03.png',
    // 'images/award04.png',
    // 'images/award05.png',
    {     
      src: 'images/mobile-digital-marketing.png',
      alt: "Mobile Digital Marketing",
    },
    {     
      src: 'images/youth-marketing-forum-awards.png',
      alt: "Youth Marketing Forum & Awards",
    },
    {     
      src: 'images/drivers-of-digital.png',
      alt: "Drivers of digital",
    },
    {     
      src: 'images/cmo-asia.png',
      alt: "CMO Asia",
    },
    {     
      src: 'images/marketing-excellence.png',
      alt: "Marketing Excellence",
    },
    // Add more image URLs here
  ];


  return (
         
    <div className="awardtop">
        <Container>
            <Row>
                <Col lg={12}>  
                <div className="awardmn">
                {images.map((image) => (
                  <img key={image.id} src={image.src} alt={image.alt} />
                ))}   
                </div>

                        {/* <ImageRow imageUrls={images} />    */}
                </Col>
            </Row>
        </Container>
    </div>
      
     
      
    
  );
};

export default ParentComponent;
